import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import cn from 'classname';
import qs from 'qs';
import moment from 'moment';

import orderBy from 'lodash/orderBy';
import noop from 'lodash/noop';

import { getCurrencyIcon } from '../../../../../../../shared/js/get-currency-icon';
import { formatMoney } from '../../../../shared/format';
import getLangSign from '../../../utils/get-lang-sign';
import avatars from '../../../../../config/avatars';
import Avatar from '../../../../shared/avatar';
import DescriptionForm from '../forms/description/main';
import CommentForm from '../forms/comment/main';
import Geos from './geos/main';

const isRocket = process.env.CPA_ENV === 'rocket';

const propTypes = {
	data: PropTypes.object,
	affiliateID: PropTypes.number,
	affiliateFilterQuery: PropTypes.string,
	loginWithAffiliate: PropTypes.func,
	toggleStatus: PropTypes.func,
	openCreateThreadFormWithAffiliate: PropTypes.func,
	openCreatePayoutFormWithAffiliate: PropTypes.func,
	openTransactionFormWithAffiliate: PropTypes.func,
	openPointsTransactionFormWithAffiliate: PropTypes.func,
	openTransferBalanceAndAccumulatedPointsForm: PropTypes.func,
	moveMoney: PropTypes.func,
	can: PropTypes.func,
	intl: PropTypes.func,
	submitDescription: PropTypes.func,
	sessionsDelete: PropTypes.func
};

const Main = ({
	data,
	affiliateID,
	affiliateFilterQuery,
	loginWithAffiliate,
	toggleRequestGarantForm,
	toggleStatus,
	openCreateThreadFormWithAffiliate,
	openCreatePayoutFormWithAffiliate,
	openTransactionFormWithAffiliate,
	toggleAddOfferFromAffiliateForm,
	openPointsTransactionFormWithAffiliate,
	openIncreaseApproveForm,
	openTransferBalanceAndAccumulatedPointsForm,
	moveMoney,
	toggleApproveDailyForm,
	can,
	intl,
	submitDescription,
	submitComment,
	setShowCommentSubmitBtn,
	showCommentSubmitBtn,
	sessionsDelete,
	updateGeos
}) => (
	<div className="profile-header">
		<div className="profile-header__main">
			<div className="profile-header__main-content">
				{data.is_master && <span className="master-label">{intl('Master')}</span>}
				<Avatar className="aff-avatar" src={data.avatar || avatars.affiliateFull}>
					{data.applicant_id && (
						<Link to={`applicants/profile/${data.applicant_id}`} target="_blank">
							<Avatar className="applicant-image" src={data.applicant_image || avatars.affiliateSmall} />
						</Link>
					)}
					<div className="id-container">{`ID  ${affiliateID}`}</div>
				</Avatar>
				<div className="aff-info">
					<p className="aff-info__label">{`Email [${intl('Nickname')}]`}</p>
					<p className="aff-info__email-lang">
						{data.has_activity_in_rocket !== null && (
							<span className={cn('margin-right-5 profile-logo-icon-rocket', {
								'profile-logo-icon-rocket-inactive': data.has_activity_in_rocket === false,
								'profile-logo-icon-rocket-active': data.has_activity_in_rocket === true
							})} />
						)}
						{data.has_activity_in_everad !== null && (
							<span className={cn('margin-right-5 profile-logo-icon-everad', {
								'profile-logo-icon-everad-inactive': data.has_activity_in_everad === false,
								'profile-logo-icon-everad-active': data.has_activity_in_everad === true
							})} />
						)}
						{data.is_suspicious && <span className="margin-right-5 icon-suspicious" />}
						{data.is_possible_fraud && <span className="margin-right-5 icon-fraud" />}
						<span className="email">{data.email}</span>
						<span className="lang">{getLangSign(data.language)}</span>
					</p>
					<p className="aff-info__nickname">[{data.nickname ? data.nickname : '-'}]</p>
					<div className="aff-info__tags">
						{data.tags &&
							data.tags.map((tag, i) => {
								const tagsQueryString = qs.stringify({
									query: {
										filters: { tags: [tag] }
									},
									entity: {
										filters: [
											{
												name: 'tags',
												values: [{ value: tag, label: tag }]
											}
										]
									}
								});

								return (
									<Link to={`affiliates?${tagsQueryString}`} key={i} className="tag">
										{tag}
										{'\u00a0'}
									</Link>
								);
							})}
					</div>
				</div>

				<div className="aff-payout">
					<table className="aff-payout-table">
						<thead className="aff-payout-table__head">
							<tr>
								<th className="balance">
									<span>{intl('Balance')}</span>
								</th>
								<th className="actions" />
								<th className="balance">
									<span>{intl('On hold')}</span>
								</th>
								<th className="currency">#</th>
							</tr>
						</thead>

						<tbody className="aff-payout-table__body">
							{Array.isArray(data.balances) &&
								prepareBalances(data.balances).map(balance => (
									<tr key={balance.currency}>
										<td className="balance">
											<span className="has-value">
												{!isNaN(balance.amount) && formatMoney(parseFloat(balance.amount), true)}{' '}
											</span>
										</td>
										{!isRocket ? (
											<td className="actions">
												<a
													href="javascript:"
													className={cn({
														'move move-to--balance': true,
														'move--active': canMoveBalance(can('moveBalance'), balance.hold_amount)
													})}
													onClick={() => {
														canMoveBalance(can('moveBalance'), balance.hold_amount)
															? moveMoney(data.id, balance.currency, 'move_to_balance')
															: noop();
													}}
												/>
												<a
													href="javascript:"
													className={cn({
														'move move-to--hold': true,
														'move--active': canMoveBalance(can('moveBalance'), balance.amount)
													})}
													onClick={() => {
														canMoveBalance(can('moveBalance'), balance.amount)
															? moveMoney(data.id, balance.currency, 'move_to_hold')
															: noop();
													}}
												/>
											</td>
										) : (
											<td className="actions" />
										)}
										<td className="balance balance--hold">
											<span>{!isNaN(balance.hold_amount) && formatMoney(parseFloat(balance.hold_amount), true)} </span>
										</td>
										<td className="currency">
											<span className="currency-sign">{getCurrencyIcon(balance.currency)}</span>
										</td>
									</tr>
								))}
							<tr>
								<td colSpan="4" className="balance">
									<span className="has-value">{data.contest_points} points</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			{isRocket && (
				<Geos
					className="profile-header__main-geos"
					updateGeos={updateGeos}
					affiliate={data}
					disabled={!can('edit')}
				/>
			)}
			{isRocket && (
				<div className="profile-header__main-description">
					<DescriptionForm
						intl={intl}
						can={can}
						onSubmit={submitDescription}
						initialValues={{
							description: data.description || ''
						}}
					/>
				</div>
			)}
			{!isRocket && (
				<div className="profile-header__main-description">
					<CommentForm
						intl={intl}
						can={can}
						submitComment={submitComment}
						showCommentSubmitBtn={showCommentSubmitBtn}
						setShowCommentSubmitBtn={setShowCommentSubmitBtn}
					/>
				</div>
			)}
			<div className="profile-header__main-controls">
				{can('payoutsCreate') && (
					<button
						onClick={() => openCreatePayoutFormWithAffiliate()}
						className="ui-btn ui-btn-primary create-payout height-55"
					>
						{intl('Create a payout')}
					</button>
				)}

				{can('createTransaction') && (
					<button
						onClick={() => openTransactionFormWithAffiliate()}
						className="ui-btn ui-btn-primary create-transaction height-55"
					>
						{intl('Transfer money')}
					</button>
				)}

				{can('createThreads') && (
					<button
						onClick={() => openCreateThreadFormWithAffiliate()}
						className="ui-btn ui-btn-primary create-ticket height-55"
					>
						{intl('Create a ticket')}
					</button>
				)}

				{can('transferPoints') && (
					<button
						className="ui-btn ui-btn-primary transfer-points height-55"
						onClick={() => openPointsTransactionFormWithAffiliate()}
					>
						{intl('Transfer points')}
					</button>
				)}
				{can('conversionsPastManualApprove') && (
					<button
						className="ui-btn ui-btn-primary height-55"
						onClick={() => openIncreaseApproveForm()}
					>
						{intl('Increase approve (closed period)')}
					</button>
				)}
			</div>
			<div className="profile-header__main-controls">
				{can('conversionsApproveDaily') && (
					<button
						className="ui-btn ui-btn-primary height-55"
						onClick={() => toggleApproveDailyForm()}
					>
						{intl('Approve daily')}
					</button>
				)}
				{can('garantApproveRequestsView') && (
					<button
						className="ui-btn ui-btn-primary height-55"
						onClick={toggleRequestGarantForm}
					>
						{intl('Request garant approve')}
					</button>
				)}
				{isRocket && can('transferBalanceAndAccumulatedPoints') && (
					<button
						className="ui-btn ui-btn-primary transfer-points height-50"
						onClick={() => openTransferBalanceAndAccumulatedPointsForm()}
					>
						{intl('Transfer balance & accumulated points to another account')}
					</button>
				)}
				{can('createTransaction') && (
					<button
						className="ui-btn ui-btn-primary height-50"
						onClick={() => toggleAddOfferFromAffiliateForm()}
					>
						{intl('Add offers from affiliate')}
					</button>
				)}
			</div>
		</div>
		<div className="profile-header__meta">
			<div className="profile-header__meta-contacts">
				<p className="label">{intl('Contacts')}</p>

				<div className="contact-item">
					<p className="type">{intl('Phone')}</p>
					<p className="value">{data.phone || '-'}</p>
				</div>

				<div className="contact-item">
					<p className="type">{intl('Skype')}</p>
					<p className="value">{(data.skype && <a href={`skype:${data.skype}?chat`}>{data.skype}</a>) || '-'}</p>
				</div>

				<div className="contact-item">
					<p className="type">{intl('Telegram')}</p>
					<p className="value">
						{(data.telegram && (
							<a href={`https://telegram.me/${data.telegram}`} target="_blank">
								{data.telegram}
							</a>
						)) ||
							'-'}
					</p>
				</div>

				<div className="contact-item">
					<p className="type">{intl('Whatsapp')}</p>
					<p className="value">
						{(data.whatsapp && (
							<a href={`https://api.whatsapp.com/send?phone=${data.whatsapp}`} target="_blank">
								{data.whatsapp}
							</a>
						)) ||
						'-'}
					</p>
				</div>
			</div>
			<div className="profile-header__meta-bottom">
				<div className="contact-item">
					<p className="type">{intl('2fa enabled')}</p>
					<p className="value">{String(data.is_two_factor_authentication_enabled)}</p>
				</div>
				<div className="contact-item">
					<p className="type">
						{intl('Manager')}
						{data.manager_regions && data.manager_regions.includes('europe') ? ` EU` : ''}
						{data.manager_regions && data.manager_regions.includes('latin') ? ` Latam` : ''}
					</p>
					{(data.manager && (
						<p className="value">
							<Avatar className="value__ava" src={data.manager_avatar ? data.manager_avatar : avatars.adminSmall} />
							<span className="value__name">{data.manager}</span>
						</p>
					)) || <p className="value">-</p>}
				</div>
				{
					!!data.additional_managers && !!data.additional_managers.length &&
					data.additional_managers.map((am, index) => (
						<div className="contact-item" key={index}>
							<p className="type">
								{intl('Manager')}
								{am.regions && am.regions.includes('latin') ? ` Latam` : ''}
								{am.regions && am.regions.includes('europe') ? ` EU` : ''}

							</p>
							{(
								<p className="value">
									<Avatar className="value__ava" src={avatars.adminSmall} />
									<span className="value__name">{am.manager_email}</span>
								</p>
							)}
						</div>
					))
				}

				<div className="contact-item">
					<p className="type">{intl('City')}</p>
					<p className="value">{data.city ? data.city.text : '-'}</p>
				</div>

				<div className="contact-item">
					<p className="type">{intl('Birthday')}</p>
					<p className="value">{formatDate(data.birthday) || '-'}</p>
				</div>

				{
					data.additional_birthdays && data.additional_birthdays.length &&
					<div className="contact-item">
						<p className="type">{intl('Additional birthdays')}</p>
						<p className="value">
							{data.additional_birthdays.map(abd => formatDate(abd) || '-').join(', ')}
						</p>
					</div>
				}

				{data.master_email && (
					<div className="contact-item">
						<p className="type">{intl('Master')}</p>
						<p className="value">
							<Avatar className="value__ava" src={data.master_avatar ? data.master_avatar : avatars.affiliateSmall} />
							<a href={`/affiliates/profile/${data.parent_id}`} target="_blank">
								<span className="value__name">{data.master_email}</span>
							</a>
						</p>
					</div>
				)}

				<div className="profile-header__meta-bottom-actions">
					{can('login') && (
						<a href="javascript:" onClick={() => loginWithAffiliate(data.id)} className="action_login" />
					)}

					{can('edit') && <Link to={`affiliates/edit/${data.id}`} className="action_edit" />}

					{can('view_threads') && (
						<Link to={`threads?${affiliateFilterQuery}`} target="_blank" className="action_threads" />
					)}

					{can('view_statistics') && (
						<Link to={`statistics?${affiliateFilterQuery}`} target="_blank" className="action_statistics" />
					)}

					{can('edit') && (
						<a
							href="javascript:"
							onClick={() => {
								if (!isRocket) {
									toggleStatus(data.id, data.status);
								} else {
									toggleStatus(data.id, data.level);
								}
							}}
							className={cn({
								action_ban: true,
								banned: isAffiliateBanned(data)
							})}
						>
							{!isRocket ? 'BAN' : (data.level === 'average' ? 'BAN' : 'ACTIVE')}
						</a>
					)}
				</div>
				<div className="profile-header__meta-bottom-actions">
					{can('sessionsDelete') && (
						<a
							href="javascript:"
							onClick={() => sessionsDelete(data.id)}
							className={cn({
								action_reset: true
							})}
						>
							reset sessions
						</a>
					)}
				</div>
			</div>
		</div>
	</div>
);

Main.propTypes = propTypes;
export default Main;

// functions
const canMoveBalance = (isAllowed, balanceAmount) => isAllowed && balanceAmount > 0;

const prepareBalances = balances => orderBy(balances, balance => balance.currency === 'usd', ['desc']);

const formatDate = (date) => {
	return moment(date).isValid() ? moment(date).format('DD.MM.YYYY') : null;
};

const isAffiliateBanned = (affiliate) => {
	return affiliate[isRocket ? 'level' : 'status'] === 'banned';
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/header/main.js